'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import * as Sentry from '@sentry/nextjs';

interface ErrorProps {
  error: Error;
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h2 className="mb-4 text-3xl font-bold text-gray-900">Etwas ist schiefgelaufen!</h2>
        <p className="mb-6 text-lg text-gray-600">
          Es ist ein unerwarteter Fehler aufgetreten. Wir entschuldigen uns für die
          Unannehmlichkeiten.
        </p>
        <div className="space-x-4">
          <button
            onClick={reset}
            className="rounded-md bg-gray-950 px-4 py-2 text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-950 focus:ring-offset-2"
          >
            Erneut versuchen
          </button>
          <Link
            href="/"
            className="rounded-md bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
